/**
 * selector String - A CSS selector
 */

export default function (selector) {
  // JS to detect if the browser supports position:sticky using Modernizr and IF it doesn't to add a CSS fallback.

  if (!Modernizr.csspositionsticky) {
    // not-supported
    // position the element with fixed
    $(selector).css({
      'position': 'fixed',
      'top': '0',
      'left': '0',
      'right': '0'
    })

    // Add an element (let's call it a "ghost") to take the vertical space of the element we're making position:fixed
    $('body').prepend('<div class="sticky-ghost">')

    // Make the ghost the same height as the item we're making position:fixed
    $('.sticky-ghost').css({'height': $(selector).outerHeight()})
  }
}
